import {
    IcatuCapPropertyPurpose,
    IcatuCapPropertyType,
} from '../../constants/icatuCap';
import { decamelizeKeys, Nullable } from '../../lib';
import { getBackVersion } from '../../config';
import { IcatuCapRiskSiteSnapshot } from '../../models/IcatuCap';
import api from '../api';

type UpsertAddressResponse = IcatuCapRiskSiteSnapshot & {
    propertyType: IcatuCapPropertyType;
    propertyPurpose: IcatuCapPropertyPurpose;
};

const upsertAddress = (
    id: string,
    address: Partial<IcatuCapRiskSiteSnapshot>,
    propertyType: Nullable<IcatuCapPropertyType>,
    propertyPurpose: Nullable<IcatuCapPropertyPurpose>
): Promise<UpsertAddressResponse> =>
    api.request<UpsertAddressResponse>({
        method: 'POST',
        url: `${getBackVersion()}/agent/cap/${id}/address`,
        data: decamelizeKeys({ ...address, propertyType, propertyPurpose }),
    });

export { upsertAddress };
export type { UpsertAddressResponse };
